import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ArticleCard from '@/components/base/ArticleCard';
import { categories, getCategoryBySlug, getArticlesByCategory } from '@/mocks/categories';

export default function Category() {
  const { slug } = useParams<{ slug: string }>();
  const category = getCategoryBySlug(slug || 'action');
  const [activeSlug, setActiveSlug] = useState(slug || 'action');

  useEffect(() => {
    if (slug) setActiveSlug(slug);
  }, [slug]);

  const activeCategory = getCategoryBySlug(activeSlug);
  const articles = getArticlesByCategory(activeSlug);

  const webpageLd = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: `${activeCategory?.name || '游戏分类'} - 黄油游戏下载`,
    description: activeCategory?.description || '游戏下载教程分类浏览',
    url: `https://www.huangyougame.com/category/${activeSlug}`,
    isPartOf: {
      '@type': 'WebSite',
      name: '黄油游戏下载',
    },
  };

  return (
    <>
      <ScrollToTop />
      <script type="application/ld+json">
        {JSON.stringify(webpageLd)}
      </script>

      <Navbar />

      <main className="pt-16">
        <section className="bg-background-100 py-8 md:py-10">
          <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
            <Breadcrumb
              items={[
                { label: '首页', href: '/' },
                { label: activeCategory?.name || '游戏分类' },
              ]}
            />
            <div className="mt-4">
              <h1 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-2">
                {activeCategory?.name}游戏下载教程
              </h1>
              <p className="text-sm text-foreground-600 max-w-2xl">
                {activeCategory?.description}
              </p>
            </div>
          </div>
        </section>

        <section className="py-8 md:py-12 bg-background-50">
          <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
            <div className="flex flex-wrap items-center gap-2 mb-8">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 cursor-pointer whitespace-nowrap ${
                    activeSlug === cat.slug
                      ? 'bg-primary-500 text-background-50 shadow-lg shadow-primary-500/20'
                      : 'bg-background-100 text-foreground-600 hover:bg-background-200 hover:text-foreground-900'
                  }`}
                >
                  <i className={`${cat.icon} mr-1.5`}></i>
                  {cat.name}
                </Link>
              ))}
            </div>

            {articles.length > 0 ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                {articles.map((article) => (
                  <ArticleCard
                    key={article.slug}
                    slug={article.slug}
                    title={article.title}
                    excerpt={article.excerpt}
                    date={article.date}
                    readTime={article.readTime}
                    imageSeq={article.imageSeq}
                    isHot={article.isHot}
                  />
                ))}
              </div>
            ) : (
              <div className="text-center py-20">
                <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4 bg-background-100 rounded-full">
                  <i className="ri-inbox-line text-2xl text-foreground-400"></i>
                </div>
                <p className="text-foreground-500">该分类暂无文章</p>
              </div>
            )}
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}